// src/components/hero/Hero.js
import React from 'react';
import ContactSection from '../contact/ContactSection';
import './Hero.css';
import './MobileHero.css'; // Import the mobile-specific styles

const Hero = () => {
  return (
    <section className="hero-section">
      {/* Main background with gradient */}
      <div className="hero-bg" style={{ 
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero_bg.jpg)` 
      }}></div>
      
      {/* Line background layer */}
      <div className="hero-line-bg" style={{ 
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero_line.png)` 
      }}></div>
      
      {/* Mobile-only text content wrapper - displayed only in mobile view */}
      <div className="mobile-text-wrapper">
        <div className="frame-48098554">
          <div className="hero-text-container">
            <h1 className="hero-title">
              <span className="orange-text">申請</span>から<span className="orange-text">住まい探し</span>まで
            </h1>
            <div className="hero-subtitle-container">
              <div className="frame-101">
                <div className="rectangle-91">
                  <img 
                    src={process.env.PUBLIC_URL + '/images/ttl_1.png'} 
                    alt="生活保護" 
                    className="ttl-1-image"
                  />
                </div>
                <span className="subtitle-connector">を</span>
                <div className="rectangle-92">
                  <img 
                    src={process.env.PUBLIC_URL + '/images/ttl_2.png'} 
                    alt="サポート！" 
                    className="ttl-2-image"
                  />
                </div>
              </div>
            </div>
            <div className="hero-description">
              <p>「体調が悪くて働けない...」</p>
              <p>「仕事を探してもなかなか見つからない...」</p>
              <p>そんな不安を抱えている方をほごらんどがサポート！</p>
              <p>生活保護の申請から住まいの確保まで、</p>
              <p>すべて無料でお手伝いします。</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Main content container - original structure for desktop */}
      <div className="hero-container">
        <div className="hero-left-container">
          {/* Frame104, Frame48098554, and HeroTextContainer components - original structure */}
          <div className="frame-104">
            <div className="frame-48098554 desktop-only">
              <div className="hero-text-container">
                <h1 className="hero-title">
                  <span className="orange-text">申請</span>から<span className="orange-text">住まい探し</span>まで
                </h1>
                <div className="hero-subtitle-container">
                  <div className="frame-101">
                    <div className="rectangle-91">
                      <img 
                        src={process.env.PUBLIC_URL + '/images/ttl_1.png'} 
                        alt="生活保護" 
                        className="ttl-1-image"
                      />
                    </div>
                    <span className="subtitle-connector">を</span>
                    <div className="rectangle-92">
                      <img 
                        src={process.env.PUBLIC_URL + '/images/ttl_2.png'} 
                        alt="サポート！" 
                        className="ttl-2-image"
                      />
                    </div>
                  </div>
                </div>
                <div className="hero-description">
                  <p>「体調が悪くて働けない...」「仕事を探してもなかなか見つからない...」</p>
                  <p>そんな不安を抱えている方をほごらんどがサポート！</p>
                  <p>生活保護の申請から住まいの確保まで、すべて無料でお手伝いします。</p>
                </div>
              </div>
            </div>
            
            {/* Merged Frame140 component - points */}
            <div className="frame-140">
              <div className="point1">
                <img 
                  src={process.env.PUBLIC_URL + '/images/point1.png'} 
                  alt="専門家が保障まで同行" 
                  className="point-image"
                />
              </div>
              <div className="point2">
                <img 
                  src={process.env.PUBLIC_URL + '/images/point2.png'} 
                  alt="生活保護の通過率99%" 
                  className="point-image"
                />
              </div>
              <div className="point3">
                <img 
                  src={process.env.PUBLIC_URL + '/images/point3.png'} 
                  alt="即日入居" 
                  className="point-image"
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="hero-image-container">
          <img 
            src={process.env.PUBLIC_URL + '/images/ogawa_pic.png'} 
            alt="生活保護サポート" 
            className="hero-model-image" 
          />

        </div>
      </div>
      
      {/* Mobile-only row for points and image */}
      <div className="mobile-row">
        <div className="mobile-points-container">
          <div className="point1">
            <img className
              src={process.env.PUBLIC_URL + '/images/point1_mobile.png'} 
              alt="専門家が保障まで同行" 
              className="point-image"
            />
          </div>
          <div className="point2">
            <img 
              src={process.env.PUBLIC_URL + '/images/point2_mobile.png'} 
              alt="生活保護の通過率99%" 
              className="point-image"
            />
          </div>
          <div className="point3">
            <img 
              src={process.env.PUBLIC_URL + '/images/point3_mobile.png'} 
              alt="即日入居" 
              className="point-image"
            />
          </div>
        </div>
        <div className="mobile-image-container">
          <img 
            src={process.env.PUBLIC_URL + '/images/ogawa_pic_sp.png'} 
            alt="生活保護サポート" 
            className="hero-model-image" 
          />
        </div>
      </div>

      {/* Contact Container - positioned below hero line but in front as a layer */}
      <div className="hero-contact-wrapper">
        <ContactSection />
      </div>
    </section>
  );
};

export default Hero;